export default "__VITE_ASSET__DrfedTJs__"